import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { TimeGrouping } from '../types/analysis.types';

interface TimeGroupingControlProps {
    value: TimeGrouping;
    onChange: (grouping: TimeGrouping) => void;
}

const OPTIONS: Array<{ value: TimeGrouping; label: string; id: string }> = [
    { value: 'daily', label: 'Dagar', id: 'timeDaily' },
    { value: 'weekly', label: 'Veckor', id: 'timeWeekly' },
    { value: 'monthly', label: 'Månader', id: 'timeMonthly' },
];

/** Tidsperiod: how the chart groups its x-axis */
const TimeGroupingControl: React.FC<TimeGroupingControlProps> = ({ value, onChange }) => (
    <div className="radio-group-horizontal">
        <span className="control-label">Tidsperiod</span>
        <div className="time-grouping-options">
            {OPTIONS.map(option => (
                <div key={option.value} className="time-grouping-option">
                    <RadioButton
                        inputId={option.id}
                        name="time-grouping"
                        value={option.value}
                        onChange={(e) => onChange(e.value as TimeGrouping)}
                        checked={value === option.value}
                    />
                    <label htmlFor={option.id}>{option.label}</label>
                </div>
            ))}
        </div>
    </div>
);

export default TimeGroupingControl;
